import CryptoJS from "crypto-js";

export default function EncryptToken(token) {
  const result = CryptoJS.AES.encrypt(
    token,
    process.env.REACT_APP_SECRET
  ).toString();
  return result;
}
